<template>
  <div id="app">
    <index />
  </div>
</template>

<script>
import Index from './components/Index.vue'
/* eslint-disable */
export default {
  name: 'App',
  components: {
    Index,
  },
  data() {
    return {}
  },
  created() {},
  methods: {},
}
</script>

<style>
/* #app {
  font-family: "Open Sans", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
</style>
